import { gql } from 'graphql-request'

export const DEPARTAMENTO_QUERY = gql`
  query DepartamentoQuery {
    departamentos {
      id
      nome
    }
  }
`
